export default __webpack_public_path__ + "79589a0cf744f3987e7215c704ffa4e0.svg";